/**
 * @module AuthApi
 *  Apis must need auth details to trigger url - AuthApi
 */
/* eslint-disable */

import axios from 'axios';
import store from '@/store/store';
import { locationUrl, locationApiToken } from '@/env';

export default {
    /**
    * Create Custom Api
    * @function
    * @param {string} url - Url to get results
    * @returns {object} A promise that will return either a success object or an error object.
    */
    customApi: (method, url, headers) => {
        return axios({
            method,
            url,
            headers,
        });
    },

    /**
     * Call to an GET Authenticate api for response.
     * @function
     * @param {string} url - Url to get results
     * @returns {object} A promise that will return either a success object or an error object.
     */
    getApi: (url, params) => {
        return axios({
            method: 'GET',
            url,
            headers: {
                // Authorization: `Bearer ${store.getters['auth/user'].token}`,
                'api-token': locationApiToken,
                'auth-token': store.getters['auth/user'].token,
            },
            params
        });
    },

    /**
   * Call to an POST Authenticate api for response.
   * @function
   * @param {string} url - Url to get results
   * @param {string} data - accept objects
   * @returns {object} A promise that will return either a success object or an error object.
   */
    postApi: (url, data) => {
        return axios({
            method: 'POST',
            url,
            headers: {
                //Authorization: `Bearer ${store.getters['auth/user'].token}`,
                'api-token': locationApiToken,
                'auth-token': store.getters['auth/user'].token,
            },
            data,
        });
    },

    /**
   * Call to an PUT Authenticate api for response.
   * @function
   * @param {string} url - Url to get results
   * @param {string} data - accept objects
   * @returns {object} A promise that will return either a success object or an error object.
   */
    putApi: (url, data) => {
        return axios({
            method: 'PUT',
            url,
            headers: {
                //Authorization: `Bearer ${store.getters['auth/user'].token}`,
                'api-token': Env.locationApiToken,
                'auth-token': store.getters['auth/user'].token,
            },
            data,
        });
    },

    /**
   * Call to an PATCH Authenticate api for response.
   * @function
   * @param {string} url - Url to get results
   * @param {string} data - accept objects
   * @returns {object} A promise that will return either a success object or an error object.
   */
    patchApi: (url, data) => {
        return axios({
            method: 'PATCH',
            url,
            headers: {
                //Authorization: `Bearer ${store.getters['auth/user'].token}`,
                'api-token': locationApiToken,
                'auth-token': store.getters['auth/user'].token,
            },
            data,
        });
    },
    /**
   * Call to an DELETE Authenticate api for response.
   * @function
   * @param {string} url - Url to get results
   * @returns {object} A promise that will return either a success object or an error object.
   */
    deleteApi: (url, data = {}) => {
        return axios({
            method: 'DELETE',
            url,
            headers: {
                //Authorization: `Bearer ${store.getters['auth/user'].token}`,
                'api-token': locationApiToken,
                'auth-token': store.getters['auth/user'].token,
            },
            data
        });
    },

    /**
   * Call to select user account
   * @function
   * @param {id} url - numeric
   * @returns {object} A promise that will return  boolean
   */
    setActiveBusiness(id) {
        // Incase blank accountId passed, prevent
        if (!id) {
            return false;
        }
        // Trigger api to get session
        const url = `${URL}/api/v1/users/businesses/${id}`;
        return this.patchApi(url)
            .then((res) => {
                // Save in store select account details
                store.dispatch('SET_USER_SELECTED_ACCOUNT', res.data.payload);
                return true;
            })
            .catch(() => false);
    },

    /**
    * this api just check whether the token is valid or not
    * @returns (boolean) true of false depending on the bearer token set
    */
    isValidToken() {
        const url = `${URL}/api/v1/users/auth/verify`;
        return this.getApi(url)
            .then(() => {
                return true;
            })
            .catch(() => false);
    },

};
